export default {
    getAllProjects: (env, groupId) => {
        return {
            url: '/groups/126/projects?per_page=100',
            method: 'GET',
            route_params: {
                groupId,
            },
        };
    },
    getProject: (env, projectId) => {
        return {
            url: '/projects/:projectId',
            method: 'GET',
            route_params: {
                projectId,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Projects/api.js